const ITEMS = [
  "PONTEGGI E MESSA IN SICUREZZA",
  "PULIZIA FACCIATE E MARCIAPIEDI",
  "RIPARAZIONE TETTI",
  "IMPERMEABILIZZAZIONE BALCONI",
  "SOSTITUZIONE GRONDAIE",
  "POTATURA ALBERI AD ALTO FUSTO",
  "SERVIZIO FABBRO",
  "TRASLOCHI E DEPOSITO",
  "INTERVENTI H24",
];

export const Marquee = () => (
  <div className="bg-[#FFD500] overflow-hidden py-3 border-y-4 border-black" data-testid="marquee" aria-hidden="true">
    <div className="marquee-track">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex shrink-0">
          {ITEMS.map((item) => (
            <span key={`${copy}-${item}`} className="font-mono-tac font-bold text-black text-sm tracking-[0.2em] uppercase whitespace-nowrap px-6">
              {item} <span className="text-black/50 px-2">✦</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
